function GetAppLayoutMock() {
  return () => Promise.resolve({ id: 'app-layout' });
}

export default GetAppLayoutMock;
